import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

interface ImagePanelProps {
  imageUrl?: string;
  label: string;
}

const ImagePanel: React.FC<ImagePanelProps> = ({ imageUrl, label }) => {
  const containerStyle: React.CSSProperties = {
    flex: 1,
    minWidth: 280,
    borderRadius: 'var(--brand-card-radius, 12px)',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
  };
  const imgStyle: React.CSSProperties = {
    width: '100%',
    aspectRatio: '4/3',
    objectFit: 'cover',
    display: 'block',
  };
  const placeholderStyle: React.CSSProperties = {
    background: '#e2e8f0',
    aspectRatio: '4/3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#94a3b8',
    fontSize: '0.875rem',
  };
  const labelStyle: React.CSSProperties = {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '0.875rem',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '10px 0',
    background: 'rgba(0,0,0,0.55)',
    color: '#fff',
  };

  return (
    <div style={containerStyle}>
      {imageUrl ? (
        <img src={imageUrl} alt={label} style={imgStyle} />
      ) : (
        <div style={placeholderStyle}>{label}</div>
      )}
      <div style={labelStyle}>{label}</div>
    </div>
  );
};

const BeforeAfter: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;

  return (
    <section className="sb-render sb-render-before-after" style={{ padding: '80px 24px', background: '#fff' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 8 }}
        >
          {sfHeadline(c, 'See the Difference')}
        </InlineEditText>
        {(sfSub(c) !== undefined) && (
          <InlineEditText
            tag="p"
            controlKey="subheadline"
            style={{ textAlign: 'center', color: '#64748b', marginBottom: 40 }}
          >
            {sfSub(c, '')}
          </InlineEditText>
        )}
        <div style={{ display: 'flex', gap: 24, alignItems: 'stretch', flexWrap: 'wrap' }}>
          <ImagePanel
            imageUrl={c.before_image as string | undefined}
            label={(c.before_label as string) || 'Before'}
          />
          <ImagePanel
            imageUrl={c.after_image as string | undefined}
            label={(c.after_label as string) || 'After'}
          />
        </div>
        {c.description !== undefined && (
          <InlineEditText
            tag="p"
            controlKey="description"
            style={{
              textAlign: 'center', color: '#64748b',
              marginTop: 32, maxWidth: 640,
              marginLeft: 'auto', marginRight: 'auto',
            }}
          >
            {c.description || ''}
          </InlineEditText>
        )}
      </div>
    </section>
  );
};

export default BeforeAfter;
